import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/exclamation_point.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-22c8479e")

_pushScopeId("data-v-22c8479e")
const _hoisted_1 = { class: "__modalsContainer __show" }
const _hoisted_2 = { class: "_clickBlocker" }
const _hoisted_3 = { class: "genericModalContent text-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = { class: "title-div" }
const _hoisted_6 = { class: "text-div" }
const _hoisted_7 = { class: "d-flex justify-content-around mt-4" }
const _hoisted_8 = { class: "fs_14 white" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "confirm-div",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent","stop"]))
        }, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode("span", null, _toDisplayString(_ctx.title), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", null, _toDisplayString(_ctx.text), 1)
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("button", {
              type: "button",
              class: "genericButton bgWhite w-50",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.returnValue(false)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_no",
                text: "No",
                class: "fs_14 spaceCadet"
              })
            ]),
            _createVNode("button", {
              type: "button",
              class: "genericButton w-50",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.returnValue(true)))
            }, [
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.confirmButton), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
})